import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { TabView, TabPanel } from "primereact/tabview";
import { BusinessInfo } from "./BusinessInfo";
import { Users } from "./users";
import Subscription from "./Subscription";
import Whitelabel from "./whitelabel";
import AIControlPanel from "./AIControlPanel";
import FbRegistration from "../FbRegistrationModule";
import { API_GET_COMPANYBYID } from "../../api/company.service";
import "./company.css";

export const Company = () => {
  const { companyId } = useParams();
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;

    const fetchCompany = async () => {
      setLoading(true);
      try {
        const companyData = await API_GET_COMPANYBYID(companyId);
        if (alive) setCompany(companyData || null);
      } catch (error) {
        console.error("Failed to fetch company:", error);
      } finally {
        if (alive) setLoading(false);
      }
    };

    if (companyId) {
      fetchCompany();
    }

    return () => {
      alive = false;
    };
  }, [companyId]);

  const summaryItems = useMemo(
    () => [
      { label: "Company ID", value: company?.id || companyId },
      { label: "Phone", value: company?.phone || "-" },
      { label: "App Name", value: company?.gupshupAppName || "-" },
      { label: "Status", value: company?.isActive ? "Active" : "Inactive" },
    ],
    [company, companyId]
  );

  return (
    <div className="page-shell company-page">
      {loading ? (
        <div className="loading-container">
          <ProgressSpinner style={{ width: "50px", height: "50px" }} />
        </div>
      ) : null}

      <div className="page-header">
        <div className="page-header-main">
          <h1 className="page-title">{company?.companyName || `Company #${companyId}`}</h1>
        </div>
        <div className="page-actions">
          <span className={`status-pill ${company?.isActive ? "success" : "warning"}`}>
            <i className="pi pi-building" />
            {company?.isActive ? "Active account" : "Inactive account"}
          </span>
        </div>
      </div>

      <div className="surface-panel company-summary-panel">
        <div className="detail-grid company-summary-grid">
          {summaryItems.map((item) => (
            <div className="detail-item" key={item.label}>
              <span className="detail-label">{item.label}</span>
              <div className="detail-value">{item.value}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="surface-panel company-tabs-shell">
        <TabView className="company-tabs">
          <TabPanel header="Business Info">
            <BusinessInfo />
          </TabPanel>
          <TabPanel header="Users">
            <Users />
          </TabPanel>
          <TabPanel header="Subscription">
            <Subscription />
          </TabPanel>
          <TabPanel header="Themes">
            <Whitelabel />
          </TabPanel>
          <TabPanel header="AI Control Panel">
            <AIControlPanel company={company} companyId={companyId} />
          </TabPanel>
          <TabPanel header="Facebook Connection">
            <FbRegistration />
          </TabPanel>
        </TabView>
      </div>
    </div>
  );
};
